/**
 * orga-app-api - qschecks-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PrueflaufRequest { 
    veranstaltung_id: string;
    pruefplan_id: string;
    rolle_id: string;
    prueflauf_id: string;
    pruefobjekt_id: string;
}

